const CLIENT_ERROR_REDUX_CONSTANT = {
  GET_CLIENT_ERROR: 'GET_CLIENT_ERROR',
};
export default CLIENT_ERROR_REDUX_CONSTANT;
